import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import './style.css';
import ReactComponent from "../ReactComponent";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	Table,
	Spin,
	Form,
	Input,
	DatePicker,
	Button,
	Icon,
	Select
} from 'antd';
import attendanceRecordService from '../../services/Attendance/attendance-record-service';


class AttendanceClockInRecord extends ReactComponent {

	dataMode = 1
	state = {
		filters: {
			current_record_date: "",
			department_id: "",
			real_name: "",
			job_number: "",
			page: 1
		},
		data: [],
		dataStatus: "unload",
	}


	actions = {
		selectAction: attendanceRecordService.selectAttendanceClockInRecord,
		exportAction: attendanceRecordService.exportAttendanceClockInRecord,
	}

	customComponentWillMount() {

		var date = new Date()
		var startyear = 2010
		var endyear = date.getFullYear()
		var res = [];
		for(var i = 0 ; endyear - i >= startyear; i++) {
			res.push(endyear - i)
		}
		this.setState({
			yearList:res
		})
	}

	setSDateFilter = event => {
		this.setState({
			filters: {
				...this.state.filters,
				start_time: moment(event).format(),
				page: 1
			}
		}, this.reloadAction)
}
setEDateFilter = event => {
	this.setState({
		filters: {
			...this.state.filters,
			end_time: moment(event).format(),
			page: 1
		}
	}, this.reloadAction)
}
onSelectStatusChange(val) {
	this.setState({
		filters: {
			...this.state.filters,
			job_status: val,
			page: 1
		}
	}, this.reloadAction)

}
	setPageFilter = pagination => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			page: pagination.current
		}
	}, this.reloadAction)

	setEmployeeFilter = value => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			badgenumber : value
		}
	}, this.reloadAction)


	setChangeEmployeeFilter = event => {
		if (!event.target.value) {
			this.setEmployeeFilter();
		}
	}

	// exportAttendanceRecord() {
	// 	let gets = {};
	// 	Object.keys(this.state.filters).forEach(key => {
	// 		if (this.state.filters[key]) {
	// 			gets[key] = this.state.filters[key];
	// 		}
	// 		attendanceRecordService.selectAttendanceCheckInOutRecord(gets,res={
	// 			if()
	// 		});
	// 	});

	// }
	Export=param=>{
		this.publicExport(this.state.filters);
	}
	render () {

		// var date = new Date
		// var endyear = date.getFullYear()
		// const yearList=this.state.yearList
		const column = [{
				title: '工号',
				dataIndex: 'badgenumber',
				key: 'badgenumber',
				className: "table-global-head"
			}, {
				title: '中文名',
				dataIndex: 'real_name',
				key: 'real_name',
				className: "table-global-head",
			}, {
				title: '打卡时间',
				dataIndex: 'checktime',
				key: 'checktime',
				className: "table-global-head",
				render:(text, record, index) => (
					moment(record.checktime).format("YYYY-MM-DD HH:mm")
				)
			}
		];
		return (
			<div className="app-module-item">
				<div style={{marginBottom: "20px"}}>
				<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.Export}>
							<Icon type="cloud-download-o" />
								<span>导出</span>
							</Button>
						</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="报告人 工号/姓名"
							onSearch={this.setEmployeeFilter}
							onChange={this.setChangeEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={null}
							enterButton />
					</div>
					{/*<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>*/}
					{/*			<Select style={{ width: 100 }} placeholder="员工状态" onChange={this.onSelectStatusChange.bind(this)}>*/}
					{/*				<Select.Option value="5">离职</Select.Option>*/}
					{/*				<Select.Option value="4">全职</Select.Option>*/}
					{/*				<Select.Option value="2">试用</Select.Option>*/}
					{/*				<Select.Option value="3">兼职</Select.Option>*/}
					{/*			</Select>*/}
					{/*</div>*/}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>结束日期 : </span>
    						<DatePicker  onChange={this.setEDateFilter}/>
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>开始日期 : </span>
    						<DatePicker  onChange={this.setSDateFilter}/>
					</div>

					<div style={{clear:"both"}}></div>
				</div>
				<div>
					{(() => {
						switch (this.state.dataStatus) {
							case "loaded":
								return (
									<Table columns={column}
									dataSource={this.state.data.Data}
									scroll={{x: 800}}
									rowKey={(record, index) => index}
									pagination={{
											total: this.state.data.Total,
											pageSize: this.state.data.PageSize,
											current: this.state.filters.page}}
									onChange={this.setPageFilter} />)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{this.state.errors && this.state.errors.map(error=><span>{error}</span>)}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
}

AttendanceClockInRecord = Form.create()(AttendanceClockInRecord)

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceClockInRecord));









// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceClockInRecord.js